export class CloudinaryConfig {
  public readonly baseApiUrl: string;
  public readonly publicImageUrl: string;
  public readonly upload: CloudinaryUploadConfig;

  constructor(baseApiUrl: string, publicImageUrl: string, upload: CloudinaryUploadConfig) {
    (this.baseApiUrl = baseApiUrl), (this.publicImageUrl = publicImageUrl), (this.upload = upload);
  }

  static parse(obj: any): CloudinaryConfig {
    if (!obj) return;

    return new CloudinaryConfig(
      obj.baseApiUrl,
      obj.publicImageUrl,
      CloudinaryUploadConfig.parse(obj.upload)
    );
  }
}

export class CloudinaryUploadConfig {
  public readonly cloud_name: string;
  public readonly upload_preset: string;

  constructor(cloud_name: string, upload_preset: string) {
    this.cloud_name = cloud_name;
    this.upload_preset = upload_preset;
  }

  static parse(obj: any): CloudinaryUploadConfig {
    if (!obj) return;

    return new CloudinaryUploadConfig(obj.cloud_name, obj.upload_preset);
  }
}
